import { ChangeEmail, ChangePassword, Profile } from "@/profile"

export default function Account() {
  return (
    <div>
      <div className="mb-6">
        <Profile />
      </div>
      <div className="mb-6">
        <ChangeEmail />
      </div>
      <div className="mb-6">
        <ChangePassword />
      </div>
    </div>
  )
}
